import { FormikErrors } from 'formik';

export const formHasErrors = <T>(errors: FormikErrors<T>): boolean =>
  Object.keys(errors).length > 0;
